const productsFeed = {
  bestsellersMain: 'BESTSELLERS_MAIN',
  makeupMain: 'MAKEUP_MAIN',
  bestsellers: 'BESTSELLERS',
  allPerfumes: 'ALL_PERFUMES',
  newArrivals: 'NEW_ARRIVALS',
  niche: 'NICHE',
  goldCollection: 'GOLD_COLLECTION',
  scentbirdProducts: 'SCENTBIRD_PRODUCTS',
  makeupLip: 'MAKEUP_LIP',
  makeupEye: 'MAKEUP_EYE',
  makeupPalettes: 'MAKEUP_PALETTES',
  lipBalms: 'LIP_BALMS',
  candles: 'CANDLES',
  bodyWashes: 'BODY_WASHES',
  moisturizers: 'MOISTURIZERS',
  cleansers: 'CLEANSERS',
  masks: 'MASKS',
  wellness: 'WELLNESS',
  eye: 'EYE',
  mens: 'MENS',
  treatments: 'TREATMENTS',
}


export default productsFeed
